import ServerConfig from '@core/models/country/ServerConfig';
import { instanceGuard } from '@core/utils/services';
import SingletonError from '../common/errors/SingletonError';
import Singleton from '../common/Singleton';
import {
    CalculatedPayout,
    calculateLottoPayout,
    PayoutConfig,
} from '@superbet-group/betting.lib.payments';

export interface ISystem {
    combinationsCount: number;
    oddValue: number;
    winningCombinationsCount: number;
}

class LottoPayoutService {
    private static instance: LottoPayoutService;
    private readonly payoutConfig: Omit<PayoutConfig, 'handlingFeeRate'>;

    public static getInstance(): LottoPayoutService {
        return instanceGuard(LottoPayoutService.instance);
    }

    public static createInstance(config: ServerConfig) {
        if (!LottoPayoutService.instance) {
            LottoPayoutService.instance = new LottoPayoutService(config);
        }
        return LottoPayoutService.instance;
    }

    private constructor(private config: ServerConfig) {
        if (LottoPayoutService.instance) {
            throw new SingletonError(this.constructor.name);
        }

        this.payoutConfig = {
            handlingFeeInverse: config.lottoBetSlip.handlingFeeInverse,
            maxWin: config.lottoBetSlip.maxWin,
            taxMode: config.lottoBetSlip.taxMode,
            taxBrackets: config.lottoBetSlip.taxBrackets,
            bonusConfig: null, // no bonus on lotto
            taxBase: config.lottoBetSlip.taxBase,
            rounding: {
                amounts: 2,
                stakeCalculations: {
                    simple: 2,
                    system: null,
                    perCombination: 8,
                },
                tax: {
                    brackets: 2,
                    total: 2,
                },
            },
        };
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete LottoPayoutService.instance;
    }

    public getPayout({
        numbersDrawn,
        selectionsCount,
        systems,
        odds,
        stake,
        handlingFeeRate
    }: {
        numbersDrawn: number;
        selectionsCount: number;
        systems: number[];
        odds: number[];
        stake: number;
        handlingFeeRate: number;
    }): CalculatedPayout {
        return calculateLottoPayout(
            numbersDrawn,
            selectionsCount,
            systems,
            odds,
            stake,
            {
                ...this.payoutConfig,
                handlingFeeRate,
            },
        );
    }
}

export default LottoPayoutService as Singleton<LottoPayoutService>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lottoBetSlip/LottoPayoutService.ts